var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("gallery " + (_vm.imageUrl !== null ? 'display' : 'hide'))},[_c('img',{staticClass:"gallery-img",attrs:{"src":("" + _vm.imageUrl)}}),_c('div',{staticClass:"gallery-desc"},[_c('span',[_vm._v(_vm._s(_vm.imageDesc))])])])}
var staticRenderFns = []

export { render, staticRenderFns }